import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Util } from "@common/utils/util";
import { ACCOUNTS } from "@constants/data-service.constant";
import { ModalService } from "@services/modal/modal.service";
import { StepsService } from "@services/steps/steps.service";
import { StorageService } from "@services/storage/storage.service";
import { GenericErrorOps } from "@shared/components/generic-error/interfaces/generic-error-ops.interface";

@Component({
    selector: "app-congelamiento-saldos-cuentas-obligatorias",
    templateUrl: "./congelamiento-saldos-cuentas-obligatorias.component.html",
    styleUrls: ["./congelamiento-saldos-cuentas-obligatorias.component.scss"],
    standalone: false
})
export class CongelamientoSaldosCuentasObligatoriasComponent implements OnInit {
  public loading: boolean = false;
  public error: boolean = false;
  public enableButtonRetry: boolean = false;
  public errorOps: GenericErrorOps;
  public ccoAmount: number = 0;
  public cdcAmount: number = 0;
  public selectedAmount: number = 0;
  public ccoCheckbox: boolean = false;
  public cdcCheckbox: boolean = false;
  @Output() ccoSelectedAmountChange = new EventEmitter<number>();
  @Output() cdcSelectedAmountChange = new EventEmitter<number>();
  @Output() ccoCheckboxChange = new EventEmitter<boolean>();
  @Output() cdcCheckboxChange = new EventEmitter<boolean>();

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly stepsService: StepsService,
    private readonly storageService: StorageService,
    private readonly modalService: ModalService,
    private readonly utils: Util
  ) {
    stepsService.setCurrentStep(1);
  }

  ngOnInit() {
    void this.initializeComponent();
  }

  private async initializeComponent() {
    const clientInfo = await this.storageService.get(ACCOUNTS);
    const accounts = clientInfo;
    this.setAccountAmounts(accounts);
  }

  private setAccountAmounts(accounts: any): void {
    const ccoAccount = accounts.find((account: any) => account.id === "CCO");
    const cdcAccount = accounts.find((account: any) => account.id === "CDC");
    this.ccoAmount = ccoAccount ? ccoAccount.amount : 0;
    this.cdcAmount = cdcAccount ? cdcAccount.amount : 0;
  }

  public numberToChileanCurrency(value: number): string {
    return this.utils.formatCurrency(value);
  }

  public ccoCheckboxClick(e: any) {
    if (!this.ccoCheckbox) {
      this.selectedAmount += this.ccoAmount;
      this.ccoCheckbox = true;
      this.ccoSelectedAmountChange.emit(this.ccoAmount);
    } else if (this.ccoCheckbox) {
      this.selectedAmount -= this.ccoAmount;
      this.ccoCheckbox = false;
      this.ccoSelectedAmountChange.emit(0);
    }
    this.ccoCheckboxChange.emit(this.ccoCheckbox);
  }

  public cdcCheckboxClick(e: any) {
    if (!this.cdcCheckbox) {
      this.selectedAmount += this.cdcAmount;
      this.cdcCheckbox = true;
      this.cdcSelectedAmountChange.emit(this.cdcAmount);
    } else if (this.cdcCheckbox) {
      this.selectedAmount -= this.cdcAmount;
      this.cdcCheckbox = false;
      this.cdcSelectedAmountChange.emit(0);
    }
    this.cdcCheckboxChange.emit(this.cdcCheckbox);
  }

  public getSelectedCCOAmmount(): string {
    if (this.ccoCheckbox) {
      return this.numberToChileanCurrency(this.ccoAmount);
    } else {
      return this.numberToChileanCurrency(0);
    }
  }

  public getSelectedCDCAmmount(): string {
    if (this.cdcCheckbox) {
      return this.numberToChileanCurrency(this.cdcAmount);
    } else {
      return this.numberToChileanCurrency(0);
    }
  }

  get isAnyAccountSelected(): boolean {
    return this.ccoCheckbox || this.cdcCheckbox;
  }
}
